import { render, staticRenderFns } from "./stopped-list-dropdown-item.component.vue?vue&type=template&id=67ae5190&scoped=true"
import script from "./stopped-list-dropdown-item.component.vue?vue&type=script&lang=js"
export * from "./stopped-list-dropdown-item.component.vue?vue&type=script&lang=js"
import style0 from "./stopped-list-dropdown-item.component.vue?vue&type=style&index=0&id=67ae5190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ae5190",
  null
  
)

export default component.exports